import { render } from "./kalio-layout.vue?vue&type=template&id=350efe38"
import script from "./kalio-layout.vue?vue&type=script&lang=js"
export * from "./kalio-layout.vue?vue&type=script&lang=js"

import "./kalio-layout.vue?vue&type=style&index=0&id=350efe38&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__